import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "flex relative" }
const _hoisted_5 = { class: "flex flex-col my-auto" }
const _hoisted_6 = {
  key: 0,
  class: "flex mb-3"
}
const _hoisted_7 = { class: "px-2 bg-brand-lime flex rounded-full" }
const _hoisted_8 = { class: "m-auto text-xxs text-brand-black pb-0.5 pt-0.5 font-medium" }
const _hoisted_9 = { class: "flex text-white text-xl font-medium mb-1.5 line-clamp-2 leading-tight" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex text-brand-light-gray text-xs line-clamp-1" }
const _hoisted_13 = { class: "flex text-brand-lime text-sm line-clamp-1" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "absolute flex top-0 left-0 p-4 w-full justify-between" }
const _hoisted_16 = { class: "flex space-x-3 my-auto w-full overflow-hidden mr-10" }
const _hoisted_17 = { class: "flex flex-col w-full my-auto -space-y-1 overflow-hidden" }
const _hoisted_18 = { class: "flex space-x-2" }
const _hoisted_19 = { class: "text-white font-medium truncate" }
const _hoisted_20 = {
  key: 0,
  class: "text-brand-black bg-brand-lime text-sm font-medium rounded-full px-3 py-1 my-auto"
}
const _hoisted_21 = {
  key: 1,
  class: "absolute flex bottom-0 left-0 p-4 w-full"
}
const _hoisted_22 = {
  key: 0,
  class: "ml-auto text-white bg-brand-black/70 backdrop-blur text-xs font-medium rounded-full px-3.5 py-2.5"
}
const _hoisted_23 = {
  key: 1,
  class: "ml-auto text-white bg-brand-black/70 backdrop-blur text-xs font-medium rounded-full px-3.5 py-2.5"
}
const _hoisted_24 = { class: "flex flex-col relative p-4" }
const _hoisted_25 = {
  key: 0,
  class: "flex absolute -top-2.5 left-4 space-x-2"
}
const _hoisted_26 = { class: "flex text-brand-black font-medium text-xxs px-1.5 py-0.5 rounded-md bg-white" }
const _hoisted_27 = {
  key: 0,
  class: "flex text-white font-medium text-xxs px-1.5 py-0.5 rounded-md bg-brand-darkish-gray"
}
const _hoisted_28 = {
  key: 1,
  class: "flex text-white font-medium text-xxs px-1.5 py-0.5 rounded-md bg-brand-darkish-gray"
}
const _hoisted_29 = { class: "flex flex-col pt-2" }
const _hoisted_30 = { class: "flex text-white text-xl font-medium mb-1.5 line-clamp-2" }
const _hoisted_31 = { class: "flex w-full bg" }
const _hoisted_32 = { class: "flex flex-col mr-8" }
const _hoisted_33 = { class: "flex text-brand-light-gray text-xs line-clamp-1" }
const _hoisted_34 = { class: "flex text-brand-lime text-sm line-clamp-1" }
const _hoisted_35 = { class: "flex min-w-fit ml-auto" }
const _hoisted_36 = {
  key: 0,
  class: "flex mt-auto"
}
const _hoisted_37 = { class: "flex space-x-1.5" }
const _hoisted_38 = {
  key: 0,
  class: "flex text-white font-medium text-xxs px-1.5 py-0.5 rounded-md bg-brand-darkish-gray min-w-max"
}
const _hoisted_39 = {
  key: 1,
  class: "flex text-white font-medium text-xxs px-1.5 py-0.5 rounded-md bg-brand-darkish-gray min-w-max"
}
const _hoisted_40 = {
  key: 1,
  class: "flex mt-auto flex-grow"
}
const _hoisted_41 = { class: "flex h-9 -space-x-2.5 overflow-hidden p-1 -mr-1" }
const _hoisted_42 = {
  key: 0,
  class: "flex h-6 w-6 rounded-full ring-2 ring-brand-black bg-brand-lime z-50 my-auto"
}
const _hoisted_43 = { class: "text-[8px] font-medium m-auto" }

import {computed, onMounted, PropType, Ref, ref} from "vue";
import {EventInterface} from "@/interfaces/EventInterface";
import UserAvatar from "@/components/UserAvatar.vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {EventType} from "@/definitions/EventType";
import {DateTime} from "luxon";
import {star} from "ionicons/icons";
import {EventPrivacy} from "@/definitions/EventPrivacy";
import pluralize from "pluralize";
import {modalController} from "@ionic/vue";
import EventContextMenu from "@/views/events/EventContextMenu.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import ApiService from "@/services/api/apiService";

const totalAvatars = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
  event: {
    type: Object as PropType<EventInterface>,
    required: true
  },
  layout: {
    type: String as PropType<'card' | 'list'>,
    default: 'card'
  },
  isNested: {
    type: Boolean,
    default: false
  },
  withContextMenu: {
    type: Boolean,
    default: true
  },
  withImage: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {


const props = __props

const authUser: Ref<UserBasicInformationInterface|undefined> = ref()

onMounted(async ()=>{
  authUser.value = await ApiService.User().authUser()
})

const eventType = computed(() => {
  switch (props.event?.type) {
    case EventType.Hotel:
      return 'Hotel'
    case EventType.Club:
      return 'Club'
    case EventType.HouseParty:
      return 'House Party'
    case EventType.Outdoors:
      return 'Outdoors'
  }
  return ''
})

const eventVisibility = computed(() => {
  switch (props.event?.visibility) {
    case EventPrivacy.Public:
      return 'Public'
    case EventPrivacy.InnerCircle:
      return 'Inner Circle'
    case EventPrivacy.InviteOnly:
      return 'Invite-only'
  }
  return ''
})

const eventDate = computed(() => {
  const startDate = DateTime.fromISO(props.event?.starts_at || '')
  const endDate = DateTime.fromISO(props.event?.ends_at || props.event?.starts_at || '')

  if (!startDate.isValid) return ''

  if (!endDate.isValid) return startDate.toFormat("EEE, d MMM 'at' HH:mm")

  const diffInHours = endDate.diff(startDate).as('hours')

  if (diffInHours === 0) return startDate.toFormat("EEE, d MMM 'at' HH:mm")
  if (diffInHours < 15) return `${startDate.toFormat("EEE, d MMM 'from' HH:mm")} - ${endDate.toFormat("HH:mm")}`
  if (startDate.toMillis() !== endDate.toMillis()) {
    return `${startDate.toFormat("EEE, d MMM 'at' HH:mm")} - ${endDate.toFormat("EEE, d MMM 'at' HH:mm")}`
  }

  return startDate.toFormat("EEE, d MMM 'at' HH:mm")
})

const contextMenu = async (event: EventInterface) => {

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: EventContextMenu,
    componentProps: {
      event
    },
    mode: 'ios'
  })

  await sheet.present()

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.layout === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (__props.event.photo_url)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({
              backgroundImage: `url('${__props.event.photo_url}')`
             }),
                    class: "w-full h-full absolute bg-cover bg-center top-0 left-0 z-50 rounded-lg"
                  }, null, 4))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex h-24 w-24 relative bg-cover bg-brand-dark-gray rounded-lg" }, [
                _createElementVNode("div", { class: "m-auto" }, [
                  _createElementVNode("svg", {
                    class: "h-6 fill-current text-brand-light-gray/20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 640 512"
                  }, [
                    _createElementVNode("path", { d: "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6zM119.8 186.4c-22.4 41.5-2.8 93.3 41.6 109.4c41.3 15 86.5-9.4 96.5-52.3l8.1-34.7L133.7 160.7l-13.9 25.7zM448.4 53.6L346.5 90.7l16.5 71L483.2 118 448.4 53.6zm71.7 132.7l-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3c44.3-16.1 64-67.9 41.6-109.4z" })
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              (__props.event.requested.length && __props.withContextMenu)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.event.requested.length) + " pending invite " + _toDisplayString(_unref(pluralize)('request', __props.event.requested.length)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, _toDisplayString(__props.event.name), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(__props.event.location), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(eventDate.value), 1)
                ])
              ])
            ])
          ]),
          (__props.withContextMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (contextMenu(__props.event)), ["stop"])),
                class: "flex my-auto pl-4 py-4"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "my-auto",
                  width: "24",
                  height: "25",
                  viewBox: "0 0 24 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M5.52035 14.5583C6.71329 14.5583 7.68035 13.5912 7.68035 12.3983C7.68035 11.2053 6.71329 10.2383 5.52035 10.2383C4.32742 10.2383 3.36035 11.2053 3.36035 12.3983C3.36035 13.5912 4.32742 14.5583 5.52035 14.5583Z",
                    fill: "#A5A7AF"
                  }),
                  _createElementVNode("path", {
                    d: "M12.0008 14.5583C13.1938 14.5583 14.1608 13.5912 14.1608 12.3983C14.1608 11.2053 13.1938 10.2383 12.0008 10.2383C10.8079 10.2383 9.84082 11.2053 9.84082 12.3983C9.84082 13.5912 10.8079 14.5583 12.0008 14.5583Z",
                    fill: "#A5A7AF"
                  }),
                  _createElementVNode("path", {
                    d: "M18.4803 14.5583C19.6732 14.5583 20.6403 13.5912 20.6403 12.3983C20.6403 11.2053 19.6732 10.2383 18.4803 10.2383C17.2874 10.2383 16.3203 11.2053 16.3203 12.3983C16.3203 13.5912 17.2874 14.5583 18.4803 14.5583Z",
                    fill: "#A5A7AF"
                  })
                ], -1)
              ]))]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.layout === 'card')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (__props.withImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{
            'h-80' : !__props.isNested,
            'h-40' : __props.isNested
          }, "flex relative bg-cover bg-brand-dark-gray"])
              }, [
                (__props.event.photo_url)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle({
              backgroundImage: `url('${ !authUser.value?.app_reviewer ? __props.event.photo_url : ''}')`
             }),
                      class: "w-full h-full absolute bg-cover bg-center top-0 left-0"
                    }, null, 4))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "m-auto" }, [
                  _createElementVNode("svg", {
                    class: "h-16 fill-current text-brand-light-gray/20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 640 512"
                  }, [
                    _createElementVNode("path", { d: "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6zM119.8 186.4c-22.4 41.5-2.8 93.3 41.6 109.4c41.3 15 86.5-9.4 96.5-52.3l8.1-34.7L133.7 160.7l-13.9 25.7zM448.4 53.6L346.5 90.7l16.5 71L483.2 118 448.4 53.6zm71.7 132.7l-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3c44.3-16.1 64-67.9 41.6-109.4z" })
                  ])
                ], -1)),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-1/3 bg-gradient-to-t from-transparent to-brand-black/95" }, null, -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(UserAvatar, {
                      "account-type-badge": false,
                      size: 7,
                      user: __props.event.organiser
                    }, null, 8, ["user"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(__props.event.organiser?.name || 'Host'), 1),
                        _createVNode(UserVerificationCheck, {
                          class: "h-4",
                          user: __props.event.organiser
                        }, null, 8, ["user"])
                      ])
                    ])
                  ]),
                  (eventVisibility.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(eventVisibility.value), 1))
                    : _createCommentVNode("", true)
                ]),
                (__props.event.capacity > 0 && __props.event.capacity_remaining <= 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (__props.event.capacity_remaining > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Only " + _toDisplayString(__props.event.capacity_remaining) + " " + _toDisplayString(_unref(pluralize)('space', __props.event.capacity_remaining)) + " left! ", 1))
                        : _createCommentVNode("", true),
                      (__props.event.capacity_remaining <= 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Guest list full! "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            (__props.withImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(eventType.value), 1),
                  (__props.event.conversations)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(__props.event.conversations) + " " + _toDisplayString(_unref(pluralize)('Conversation', __props.event.conversations)), 1))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(__props.event.interested.length) + " " + _toDisplayString(__props.event.interested.length < 2 ? 'person is' : 'people are') + " interested in this event ", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(__props.event.name), 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(__props.event.location), 1),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(eventDate.value), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (!__props.event.public_guest_list)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          (__props.event.attending.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(__props.event.attending.length) + " attending ", 1))
                            : _createCommentVNode("", true),
                          (__props.event.interested.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(__props.event.interested.length) + " interested ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.event.public_guest_list)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.event.attending.slice(Math.max(__props.event.attending.length - totalAvatars, 0)), (attendee) => {
                            return (_openBlock(), _createBlock(UserAvatar, {
                              "account-type-badge": false,
                              "account-activity": false,
                              "custom-class": "ring-2 ring-brand-black my-auto",
                              size: 6,
                              key: attendee.id,
                              user: attendee
                            }, null, 8, ["user"]))
                          }), 128)),
                          ((__props.event.attending.length - totalAvatars) > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, "+" + _toDisplayString(__props.event.attending.length - totalAvatars), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})